import {vec2, mat2d} from "gl-matrix"
import {Vector2} from "./Vector2";

export const getTranslation = (m: mat2d): Vector2 => new Vector2(m[4], m[5])
export const roundToPixels = (m: mat2d) => {

    m[4] = Math.round(m[4])
    m[5] = Math.round(m[5])
}


const tempMatrix = mat2d.create();
const tempVec = vec2.fromValues(0, 0)
export const transform = (transformMatrix: mat2d, vector: Vector2): Vector2 => {
    vec2.set(tempVec, vector.x, vector.y)
    mat2d.fromTranslation(tempMatrix, tempVec)
    mat2d.mul(tempMatrix, transformMatrix, tempMatrix)
    return getTranslation(tempMatrix)
}